<template>
  <div 
    class="popupWrap" 
    :class="{ 'active' : openOrClose }" 
    @click="dimmedClickHandler" 
  >
    <div class="contentWrap" ref="contentWrap">

      <div class="popWrap">
        <h2>프로토콜 추가하기</h2>
        <div class="cont">
          <input 
            ref="inputWrite"
            type="text" 
            placeholder="새 프로토콜 명을 입력하세요." 
            v-model="inputText" 
          >
        </div>
        <div class="btns">
          <btn-link :style="{minWidth: '60px'}" @click="clickCloseHandler">취소</btn-link>
          <btn-link color="blue" :style="{minWidth: '80px'}" @click="addHandler">생성하기</btn-link>
        </div>
        <CloseBtn :closeHandler="clickCloseHandler" />
      </div>

    </div>
  </div>
</template>

<script>
import BtnLink from '@components/btns/BtnLink.vue'; 
import CloseBtn from '@components/btns/CloseBtn.vue'; 
export default {
  props : {
    addProtocolObj : Object , 
  } , 
  components : {
    BtnLink , 
    CloseBtn , 
  } , 
  data () {
    return {
      inputText : '' , 
    }
  } , 
  watch : {
    'addProtocolObj.openBln' : {
      handler ( bln ) {
        if ( bln ) {
          setTimeout(_=> {
            this.$refs.inputWrite.focus() ; 
          } , 100 ) ; 
        }
      }
    }
  } , 
  computed : {
    openOrClose () {
      return this.addProtocolObj.openBln ; 
    } , 
  } , 
  mounted () {} , 
  methods : {
    addHandler ( e ) {
      this.addProtocolObj.addNewProtocol({
        text : this.inputText , 
      }) ; 
      this.clickCloseHandler( e ) ; 
    } , 
    clickCloseHandler ( e ) {
      e.preventDefault() ; 
      e.stopPropagation() ; 

      this.inputText = '' ; 
      this.addProtocolObj.closeHandler() ; 
    } , 
    dimmedClickHandler ( e ) {
      if ( !this.addProtocolObj.openBln ) return ; 
      if ( !this.$refs.contentWrap.contains( e.target ) ) {
        // this.addProtocolObj.closeHandler() ; 
      }
    } , 
  } , 
}
</script>

<style lang="scss" scoped>
.popupWrap {
  border: 1px solid #000;
  position: fixed; 
  z-index: 99; 
  left: 0; top: 0; width: 100%; height: 100%; 
  display: flex; 
  justify-content: center; align-items: center; 
  visibility: hidden; 
  transition: visibility 0.475s , backdrop-filter 0.475s; 
  backdrop-filter: blur( 0px ); 

  .contentWrap {
    display: flex; 
    flex-direction: column; 
    // width: 992px; 
    // height: 723px; 
    padding: 24px; 
    gap: 24px;
    background-color: $white; 
    border: 1px solid $gray-9; 
    position: relative; 
    opacity: 0; 
    transform: scale( 0 ); 
    transition-property: transform , opacity; 
    transition-duration: 0.475s , 0.475s; 
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.125);

    > h2 {
      display: flex; 
      flex-shrink: 0; 
      align-items: center; 
      height: 24px; 
    }

    .scrlWrap {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap; 
      align-items: flex-start;
      padding: 0px;
      // gap: 16px; 
      gap: 24px var( --default-gap ); 

      width: 944px;
      height: 627px;
      overflow: hidden; 
      overflow-y: auto;

      @include scrlbar;
    } // end of .scrlWrap 
    
    .closeBtn {
      font-size: 0; 
      width: 24px; height: 24px; 
      display: flex; 
      justify-content: center; 
      align-items: center; 
      position: absolute; 
      right: 24px; top: 24px; 
      cursor: pointer;
      svg {
        width: 14px; height: 14px; 
      }
    } // end of .closeBtn 
  } // end of .contentWrap

  &.active {
    visibility: visible; 
    // backdrop-filter: blur( 2px ); 
    .contentWrap {
      opacity: 1; 
      transform: scale( 1 ); 
    }
  } // end of .active 
  .popWrap {
    display: flex; 
    flex-direction: column; 
    gap: 24px; 
    > h2 {
      height: 24px; 
      display: flex; 
      align-items: center; 
    }
    .cont {
      > input[type=text] {
        width: 400px; 
        height: 40px; 
        border: 1px solid $gray-9; 
        padding: 0 8px; 
        &::placeholder {
          color: $gray-d; 
        }
      }
    } // end of .cont 

    .btns {
      display: flex; 
      justify-content: center; 
      gap: 8px; 
    }
  } // end of .popWrap 


} // end of .popupWrap
</style>